import { Component, OnInit } from '@angular/core';
import { GroupBudgetService } from '../../Services/groupBudget.service';
import { AuthService } from '../../Services/auth.service';
import { GroupService } from '../../Services/group.service';
import { MemberService } from '../../Services/member.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-group-list',
  template: require('./group-budget-view.component.html'),
  styles: [require('./group-budget-view.component.css')]
})
export class GroupBudgetViewComponent implements OnInit {
  groupbudget: any[] = [];
  groups: any[]=[];
  yearsAvailable : any[] = [];
  selectedYear: number = 0;
  selectedGroup:number = -1;
  inputAmount:number = 0;
  currentTicketId: number=-1;
  currentGroupTickets: any[]=[];
  viewGroupId: number=-1;

  showSearched:boolean =false;
  selectedMemberId:number= -1;
  selectedMember: string = "";
  nameSearchString: string = '';

  all_members:any[] =[];
  searched_members: any[] = [];
  firstnames: any[] = [];
  lastnames: any[] = [];

  constructor(private groupBudgetSerice: GroupBudgetService, 
    private auth: AuthService, 
    private groupService: GroupService,
    private memberService: MemberService
  ) { }

  ngOnInit() {
    this.loadAll()
  }

  loadAll(){
    this.groupBudgetSerice.getYearsAvailable().subscribe( (res:any) =>{
      if (res.status == 200){
        this.yearsAvailable = res.value
        this.selectedYear = this.yearsAvailable[0];
        this.loadAllBudgetAmountsForYear();
      }
    });

    this.groupService.getGroupNames(true).subscribe( (res:any)=>{
      this.groups = res
    })
  }

  loadMembers(){
    this.memberService.getMembers().subscribe( (res:any)=>{
      this.all_members = res;
    })
  }

  yearSelected(){
    this.loadAllBudgetAmountsForYear()
  }

  SetCurrentGroupId(id:number){
    this.viewGroupId = id

    this.loadCurrentGroupTicketsBySelectedYear()
    
  }

  loadCurrentGroupTicketsBySelectedYear(){
    this.groupBudgetSerice.getTicketsByGroupAndYear(this.selectedYear, this.viewGroupId).subscribe( (res:any)=>{
      if (res.status == 200){
        this.currentGroupTickets = res.value;
      }
      
    } )
  }

  loadAllBudgetAmountsForYear(){
    this.groupBudgetSerice.getAllGroupBudget(this.selectedYear).subscribe( (x:any)=>{
      if (x.status == 200){
        this.groupbudget = x.value;
      }
      
    })
  }

  Save(){
    var dataToSend = {
      "id":this.currentTicketId,
      "groupId": this.selectedGroup,
      "AmountUsed": this.inputAmount,
      "ReceiverName": this.selectedMember
    }

    this.groupBudgetSerice.addTicket(dataToSend).subscribe( (res:any)=>{
      this.loadAllBudgetAmountsForYear()
    })

  }

  searchName(){
    // console.log(this.members);
    if (this.all_members.length > 0){
      let f = this.all_members.filter( (a:any)=> a.firstName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      let l = this.all_members.filter( (a:any) => a.lastName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;

      if (f.length > 0) {
        this.searched_members = f
      }
      if (l.length > 0) {
        this.searched_members = this.searched_members.concat(l)
      }
      this.showSearched = true;
        
      }else{
        this.searched_members = this.all_members;
        this.showSearched = false;
      }
  }

  clearInput(){
    this.showSearched = false;
    this.selectedMemberId = -1;
    this.selectedMember = "";
    this.nameSearchString = '';
    this.selectedGroup = -1;
    this.inputAmount = 0;

  }

  removeGroupTicket(ticketID: number){

    Swal.fire({
          title: 'Ben je zeker?',
          text: "Ben je zeker dat je dit wil verwijderen?",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Jep',
          cancelButtonText: 'Nope'
        }).then((result) => {
          if (result.value) {
            this.groupBudgetSerice.delTicket(ticketID).subscribe( (res:any)=>{
              if (res.status == 200){
                this.loadCurrentGroupTicketsBySelectedYear()
                
              }
          })
          }
        });

    
  }

  getActiveClass(id:number){
    var s = 'list-group-item'
    if (id === this.selectedMemberId){
     s += ' active'
    }
    return s;
 }
 MemberSelect(id:number){
  this.selectedMemberId = id;
  var member = this.searched_members.find( x=> x.id === id)
  this.selectedMember = member.firstName +" "+member.lastName;
  this.nameSearchString = this.selectedMember;
  // this.volunteer.firstName = ;
  // this.volunteer.lastName = ;  
}

getColor(g:any){
  if (g.maxAmount > 0){
    var percent = (g.amountused / g.maxAmount) * 100;
    
   
     if (percent >= 90){
      return "#ff4545"
    } else if ( percent >= 70){
      return "#FFA500"
    }
    
  }
  
}


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/group-budget-view/group-budget-view.component.ts